module.exports = __webpack_public_path__ + "img/invoice2.2ec293fb.png";